<template>
  <div className="animated">
    <div class="animated fadeIn">
      <b-row class="my-2">
        <b-col>
          <h1 class="text-uppercase font-weight-bold">{{ $route.meta.label }}</h1>
        </b-col>
        <b-col>
          <span class="float-right">
            <b-button size="sm" class="ml-1">boton 1</b-button>
            <b-button size="sm" class="ml-1">boton 2</b-button>
          </span>
        </b-col>
      </b-row>
      <div>
        <b-table
          sticky-header="600px"
          :no-border-collapse="true"
          small
          hover
          :busy="loading"
          responsive
          :items="items"
          :fields="fields"
        >
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>
          <!-- We are using utility class `text-nowrap` to help illustrate horizontal scrolling -->
          <template #head()="scope">
            <div
              class="text-nowrap clicable"
              @click.prevent="onHeaderClick(scope)"
              v-if="scope.column != 'week' && scope.column != 'total' && scope.column != 'kgDia'"
            >
              {{ scope.label }} <br />
              {{ columnSum(scope.label) | formatNumber }}
            </div>
          </template>
          <template #cell()="scope">
            <div
              class="text-nowrap clicable"
              v-if="scope.field.key != 'week' && scope.field.key != 'total' && scope.field.key != 'kgDia'"
              @click.prevent="$bvModal.show(scope.item.week + '-' + scope.field.key)"
            >
              <week-market-detail
                :id="scope.item.week + '-' + scope.field.key"
                :market="getMarketId(scope.field.key)"
                :week="scope.item.week"
                :title="scope.field.key + ': ' + scope.item.week"
                :data="scope.item"
                :market-allowed-containers="getMarketAllowedContainers(scope.field.key)"
                @hide="onHide"
              ></week-market-detail>
              <div v-if="parseFloat(scope.item[scope.field.key].total) > 0">
                {{ scope.item[scope.field.key].current | formatNumber }} /
                {{ scope.item[scope.field.key].total | formatNumber }}
                <b-badge :variant="scope.item[scope.field.key].percentage === 100 ? 'success' : 'light'"
                  >{{ scope.item[scope.field.key].percentage | formatNumber }}%</b-badge
                >
              </div>
              <div v-else>0</div>
            </div>
            <div v-else>{{ scope.item[scope.field.key] | formatNumber }}</div>
          </template>
          <template> </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import WeekMarketDetail from "./WeekMarketDetail.vue";
import mountPlan from "./mountPlan.js";

export default {
  name: "Plan",
  components: {
    WeekMarketDetail
  },
  data() {
    return {
      ready: false,
      loading: true,
      stickyHeader: false,
      noCollapse: false,
      fields: [],
      items: [],
      markets: []
    };
  },
  methods: {
    onHide() {
      this.doMount();
    },
    columnSum(column) {
      let sum = 0;
      if (this.items.length > 0) {
        this.items.forEach((item) => {
          if (item[column] && item[column].total) {
            sum += parseFloat(item[column].total);
          }
        });
      }
      return sum;
    },
    async doMount() {
      this.markets = await this.getMarkets();
      const plan = await this.getPlan();
      this.ready = true;
      mountPlan(this.markets, plan).then((data) => {
        this.items = data.items;
        this.fields = data.fields;
        this.loading = false;
      });

      this.loading = false;
    },
    onHeaderClick(item) {
      this.$router.push({
        name: "comercial-plan-detail",
        params: { id: this.getMarketId(item.column), market: this.markets.find((e) => e.name === item.column).name }
      });
    },
    async getMarkets() {
      this.loading = true;
      try {
        const response = await this.$axios.get(
          "/api/comex/market/?no_page&omit=s_accepted_varieties,s_accepted_containers,s_accepted_classifications"
        );
        return response.data;
      } catch (error) {
        console.log(error);
        return [];
      }
    },
    getMarketId(marketName) {
      let market = this.markets.find((m) => m.name === marketName);
      return market.id;
    },
    getMarketAllowedContainers(marketName) {
      let market = this.markets.find((m) => m.name === marketName);
      return market.accepted_containers;
    },
    async getPlan() {
      this.loading = true;
      try {
        const response = await this.$axios.get("/api/comex/plan/?no_page");
        return response.data;
      } catch (error) {
        console.log(error);
        return [];
      }
    }
  },
  mounted() {
    this.doMount();
  }
};
</script>

<style scoped>
.clicable {
  cursor: pointer !important;
}
>>> .clicableCell:hover {
  background-color: #c6ccd0 !important;
}

>>> table tr {
  white-space: nowrap;
}

>>> .b-table-sticky-column:nth-last-child(2),
.b-table-sticky-column:nth-last-child(1) {
  right: 0;
}
/* inner shadow */
/* box-shadow: 0 0 0px 0px rgb(160 160 160 / 10%), inset 0 0 2px 2px rgb(130 130 130 / 10%); */
</style>
